import { ReduxAction } from '../../ReduxStorage/actions';
import { INITIAL_STATE } from './state';
import { ActionTypes } from './actions';
import { UserpilotState } from './types';

export const Userpilot = (
  state: UserpilotState = INITIAL_STATE,
  action: ReduxAction
): UserpilotState => {
  switch (action.type) {
    case ActionTypes.USERPILOT_SCRIPT_LOADED:
      return {
        ...state,
        scriptLoaded: true,
      };
    default: {
      return state;
    }
  }
};
